import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
// import { format } from 'date-fns';
// import { File_URL } from "../config/settings";
import CorporateAproveDecline from "./CorporateAproveDecline";

const CorporateModalInfo = ({ corporateDetails }) => {
  const tagData = [
    {
      title: "Address:",
      discription: corporateDetails?.corporateInformation?.address,
    },
    {
      title: "City:",
      discription: corporateDetails?.corporateInformation?.city,
    },
    {
      title: "Email Address:",
      discription: corporateDetails?.corporateInformation?.emailAddress,
    },
    {
      title: "Fax Number:",
      discription: corporateDetails?.corporateInformation?.faxNo,
    },
    {
      title: "Intrest Group:",
      discription: corporateDetails?.corporateInformation?.interestGroups,
    },
    {
      title: "IT Intrest Area:",
      discription: corporateDetails?.corporateInformation?.itInterestArea,
    },
    {
      title: "Liability:",
      discription: corporateDetails?.corporateInformation?.liability,
    },
    {
      title: "Name of Organization:",
      discription: corporateDetails?.corporateInformation?.nameOfOrganzation,
    },
    {
      title: "Number of Employee:",
      discription: corporateDetails?.corporateInformation?.noOfEmployees,
    },
    {
      title: "Phone Number:",
      discription: corporateDetails?.corporateInformation?.phoneNumber,
    },
    {
      title: "Postal Address:",
      discription: corporateDetails?.corporateInformation?.postalAddress,
    },
    {
      title: "Product or Service:",
      discription: corporateDetails?.corporateInformation?.productOrService,
    },
    {
      title: "RC Number:",
      discription: corporateDetails?.corporateInformation?.rcNo,
    },
    {
      title: "State:",
      discription: corporateDetails?.corporateInformation?.state,
    },
    {
      title: "Type of Business:",
      discription: corporateDetails?.corporateInformation?.typeOfBussiness,
    },
    {
      title: "Year of Incorporation:",
      discription: corporateDetails?.corporateInformation?.yearOfIncorporation,
    },
  ];

  return (
    <Box>
      {/* <Flex justifyContent={'flex-start'} alignItems={'center'} my={6} >
        <Image src={`${File_URL}${corporateDetails?.corporateInformation?.passport}`} alt='Profile Pics' rounded={'full'} width={'183px'} height={'183px'} overflow={'hidden'} objectFit={'cover'} border={'5px solid #23A455CC'} objectPosition={'center'} />
      </Flex> */}
      <Box h={"250px"} overflow={"scroll"}>
        {tagData?.map((data, index) => (
          <Flex
            px={[1, null, null]}
            my={5}
            fontSize={"18px"}
            fontWeight={"500"}
            fontFamily={"roboto"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            mb={4}
            key={index}
            gap={[6, 3, 3]}
          >
            <Text
              width={"35%"}
              color={"#121212"}
              fontWeight={"400"}
              lineHeight={"18.9px"}
            >
              {data.title}
            </Text>
            <Text width={"65%"} color={"#7A7A7A"} lineHeight={"21.09px"}>
              {data.discription}
            </Text>
          </Flex>
        ))}{" "}
        {!corporateDetails?.memberCategory && (
          <CorporateAproveDecline corporateDetails={corporateDetails} />
        )}
      </Box>
    </Box>
  );
};

export default CorporateModalInfo;
